import api from './api'

// ── Translate camelCase Redux filter keys → snake_case backend params ─────────
// FIX Bug 14 (CORS): owner names with spaces (e.g. "Priya Nair") were causing
// CORS preflight failures because axios wasn't encoding spaces in query strings
// consistently across all browsers. Solution: encode values explicitly.
const toApiParams = (params = {}) => {
  const map = {
    riskLevel:  'risk_level',
    amountMin:  'amount_min',
    amountMax:  'amount_max',
    dateFrom:   'date_from',
    dateTo:     'date_to',
  }
  const out = {}
  Object.entries(params).forEach(([k, v]) => {
    if (v === '' || v == null) return
    const key = map[k] || k
    // Trim strings to avoid accidental space-in-URL issues
    out[key] = typeof v === 'string' ? v.trim() : v
  })
  return out
}

const alertsService = {
  // FIX: all list calls go through toApiParams for consistent key translation
  getList: (params = {}) =>
    api.get('/api/v1/alerts', { params: toApiParams(params) }).then(r => r.data),

  getById: (id) =>
    api.get(`/api/v1/alerts/${id}`).then(r => r.data),

  assign: (id, assignee, team) =>
    api.patch(`/api/v1/alerts/${id}/assign`, { assignee, team }).then(r => r.data),

  // decision param = action key (MARK_SAFE, RISK_HOLD, etc.)
  // comment param  = risk_comment text
  // Updated per Vikas (Risk Team) — action replaces decision, risk_comment mandatory for closing actions
  decide: (id, action, risk_comment) =>
    api.post(`/api/v1/alerts/${id}/decision`, {
      action,
      risk_comment: risk_comment || null,
      decision: action,    // backward compat
    }).then(r => r.data),

  escalate: (id, reason) =>
    api.post(`/api/v1/alerts/${id}/escalate`, { reason }).then(r => r.data),

  addComment: (id, comment) =>
    api.post(`/api/v1/alerts/${id}/comments`, { comment }).then(r => r.data),

  getRelated: (id) =>
    api.get(`/api/v1/alerts/${id}/related`).then(r => r.data),

  getInvestigation: (params) =>
    api.get('/api/v1/alerts/investigation', { params: toApiParams(params) }).then(r => r.data),

  export: (params = {}) =>
    api.get('/api/v1/alerts/export', {
      params: toApiParams(params),
      responseType: 'blob',
    }).then(r => r.data),

  // Guard against undefined txn_id
  getTransaction: (txn_id) => {
    if (!txn_id || txn_id === 'undefined') return Promise.resolve(null)
    return api.get(`/api/v1/transactions/${txn_id}`).then(r => r.data)
  },

  // Optional DeviceShield enrichment. The backend returns { available: false }
  // when no device context exists; a disabled connector may return 404.
  getDeviceContext: (alertId) =>
    api.get(`/api/v1/integrations/deviceshield/alerts/${alertId}/context`).then(r => r.data),

  refreshDeviceContext: (alertId) =>
    api.post(`/api/v1/integrations/deviceshield/alerts/${alertId}/context/refresh`).then(r => r.data),

  getDeviceShieldHealth: () =>
    api.get('/api/v1/integrations/deviceshield/health').then(r => r.data),

  // Expose for direct use in components
  toApiParams,
}

export default alertsService
